import React from 'react';
import styled from 'styled-components';
import { Box } from '@landr/maestro';
import MerchZone from 'components/MerchZone/MerchZone';
import InstrumentsCardsGroup from 'components/InstrumentsCardsGroup/InstrumentsCardsGroup';
import { PageBody } from 'components/PageLayout';
import HeroCarousel from 'components/HeroCarousel/HeroCarousel';
import HeroSearch from 'components/HeroSearch/HeroSearch';
import PricingCards from 'components/PricingCards/PricingCards';
import LoadingHero from 'components/LoadingHero/LoadingHero';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import useAppNavigationMeta from 'hooks/useAppNavigationMeta/useAppNavigationMeta';
import { PromotionalCards } from 'components/PromotionalCards';
import { Charts } from 'components/Charts/Charts';
import { JumpToHashLink } from 'components/JumpToHashLink/JumpToHashLink';
import { withErrorBoundary } from 'error';
import { SamplesUsps } from 'components/SamplesUsps/SamplesUsps';

const Container = styled(Box)`
    min-height: 60vh;
    z-index: 1;
    position: relative;
`;

const ForYouHeader = () => {
    const {
        isGuestUser,
        isAuthenticated,
        isLoading: isAuthenticationLoading,
    } = useAuthentication();
    const { responsiveNavHeight } = useAppNavigationMeta();
    const showHeroCarousel = isAuthenticated;

    return (
        <Container mt={responsiveNavHeight * -1}>
            {isAuthenticationLoading && <LoadingHero />}
            {isGuestUser && <HeroSearch />}
            {showHeroCarousel && <HeroCarousel />}
        </Container>
    );
};

const ForYou = () => (
    <>
        <ForYouHeader />
        <PageBody>
            <JumpToHashLink hash="#new-releases">
                <MerchZone key="for_you_top" slug="for_you_top" />
            </JumpToHashLink>
            <JumpToHashLink hash="#features">
                <PromotionalCards />
            </JumpToHashLink>
            <MerchZone key="for_you_middle" slug="for_you_middle" />
            <JumpToHashLink hash="#charts">
                <Charts />
            </JumpToHashLink>
            <JumpToHashLink hash="#top-instruments">
                <InstrumentsCardsGroup key="instruments-cards-group" />
            </JumpToHashLink>
            <MerchZone key="for_you_bottom" slug="for_you_bottom" />
            <SamplesUsps key="samples-usps" />
            <JumpToHashLink hash="#pricing">
                <PricingCards />
            </JumpToHashLink>
        </PageBody>
    </>
);

export default withErrorBoundary(ForYou, 'page');
